/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

export type ModuleMetadataWorkingMode = 'custom' | 'classic_essays' | 'ai_tutor_oral' | null;
